<template>
	<div class="date-wrap">
    <span v-if="context !== 'snapshot'" class="label">{{ title }}<span v-if="showAge()" class="date-age">Age: <b v-html="setAge()"></b></span></span>
    <div class="date-segment date-segment--month">
      <Dropdown v-on:updateDate="updateSnapshotDate" :id="setId('date-month')" :field="setField('month')" label="Month" proto="months" :context="context"></Dropdown>
    </div><!--
 --><div class="date-segment date-segment--day">
      <Dropdown v-on:updateDate="updateSnapshotDate" :id="setId('date-day')" :field="setField('day')" label="Day" proto="days" :context="context"></Dropdown>
    </div><!--
 --><div class="date-segment date-segment--year">
      <Dropdown v-on:updateDate="updateSnapshotDate" :id="setId('date-year')" :field="setField('year')" label="Year" :proto="getYears" :context="context"></Dropdown>
    </div>
    <div v-if="context === 'snapshot'" class="date-updater">
      <button @click="reassignSnapshotDate()" class="date-save">(save changes)</button>
    </div>
	</div>
</template>

<script>

import Dropdown from './Dropdown.vue'

export default {

  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
  components: {
    Dropdown
  },  

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    updateSnapshotDate(vars) {
      
      this.$data.snapshotDate[vars.field] = vars.value;

    },

    reassignSnapshotDate() {

      var newkey = this.$data.snapshotDate.year +
                    window.padDigits(this.$data.snapshotDate.month, 2) + 
                    window.padDigits(this.$data.snapshotDate.day, 2);

      if ( this.snapshot !== newkey ) {
        this.$store.dispatch('updateSnapshotDate', {
          key : this.snapshot,
          newkey : newkey
        });
      }

      this.$emit('updateDate');

    },

    setField(field) {

      return this.field + '.' + field;

    },

    setId(seg) {

      return this.id + '-' + seg;

    },

    setAge() {

      var dob = this.$store.getters.getFieldData({field: 'details.dateOfBirth'});

      dob.year = (dob.year === '0') ? '1980' : dob.year;
      dob.month = (dob.month === '0') ? '1' : dob.month;
      dob.day = (dob.day === '0') ? '1' : dob.day;

      var today = new Date(),
          dob_date = new Date(dob.year, dob.month-1, dob.day);

      if ( this.field === 'details.dateOfBirth' ) {

        var age = today.getFullYear() - dob_date.getFullYear(),
        m = today.getMonth() - dob_date.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < dob_date.getDate())) {
            age--;
        }      

        return age;

      } else {

        var field_date = this.$store.getters.getFieldData({field: this.field}),
            date = new Date(field_date.year, field_date.month-1, field_date.day),
            ageDifMs = date - dob_date,
            ageDate = new Date(ageDifMs);

        return Math.abs(ageDate.getUTCFullYear() - 1970);

      }

    },

    showAge() {

      if ( this.showage === 'true' ) {

        return true;

      }

      return false;

    }

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    getYears: function() {
      return ( this.yearOrder === 'asc') ? 'yearsAsc' : 'years';
    }

  },

  mounted: function() {

    if ( this.snapshot ) {
      var date = this.snapshot;
      this.$data.snapshotDate = {
        day: date.substr(6),
        month: date.substr(4,2),
        year: date.substr(0,4)
      }
    }

  },

  props : [
  	'title', 
    'field', 
    'showage',
    'context',
    'snapshot',
    'id',
    'yearOrder',
  ],

  data() {

    return {

      snapshotDate: {
        day: "01",
        month: "01",
        year: "1980",
      }

    }

  }

}

</script>

<style lang="scss">

  .date-segment {

    width: calc(33.3333% - .5rem);
    display: inline-block;
    margin-left: .5rem;

  }

  .date-segment--month {

    width: 33.3333%;
    margin-left: 0;

  }

  .date-age {

    margin-left: .5em;

    &::before {

      content: '(';

    }

    &::after {

      content: ')';

    }

    b {

      color: #06a0df;
      
    }

  }

  .date-save {

    appearance: none;
    border: 0;
    background: 0;
    padding: 0;
    font-size: .75rem;
    position: relative;
    top: -.5em;
    letter-spacing: .1em;
    color: #06a0df;

    &:hover,
    &:focus,
    &:active {

      color: #103c63;

    }

  }


</style>



// WEBPACK FOOTER //
// DatePicker.vue?0f3ba809